import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const GuideHero = ({ title, subtitle, description, backLabel = 'Back to Complete Fly Selection Guide' }) => (
  <section className="relative py-20 bg-gradient-to-br from-cyan-600 to-cyan-800 text-white" data-testid="guide-hero">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <Link to="/fly-guide" className="inline-flex items-center text-cyan-100 hover:text-white mb-6 transition-colors">
        <ArrowLeft className="w-5 h-5 mr-2" />
        {backLabel}
      </Link>
      <h1 className="text-4xl sm:text-5xl font-bold mb-6">{title}</h1>
      {subtitle && <h2 className="text-2xl font-semibold mb-4">{subtitle}</h2>}
      <p className="text-xl text-cyan-100">{description}</p>
    </div>
  </section>
);

export default GuideHero;
